import createAxios from './axiosHttp';
export const paisService = {
  getPaises
};

function getPaises() {
  const axios = createAxios();
  let urlPath = '/country';
  return axios.get(urlPath);
}